const initialState = {
    platformStatistics: null,
    platformStatisticsStatus: "NOT LOADED",
    transcriptsVideoList: [],
    transcriptsVideoListStatus: "NOT LOADED",
    uploadTranscriptStatus: "NOT LOADED",
    uploadTranscriptResult: {},
    videosToCurate: [],
    videosToCurateStatus: "NOT LOADED",
    classCodesList: [],
    classCodesListStatus: 'NOT LOADED',
    classCodeDetail: {
        roster: []
    },
    classCodeDetailStatus: "NOT LOADED"
}

export default (state=initialState, action) => {
    switch(action.type){
        case "SET_UPLOAD_TRANSCRIPT_RESULT":
            return Object.assign({}, state, { uploadTranscriptResult: action.data})
        case "SET_UPLOAD_TRANSCRIPT_STATUS":
            return Object.assign({}, state, { uploadTranscriptStatus: action.status })
        case "SET_PLATFORM_STATISTICS":
            return Object.assign({}, state, { platformStatistics: action.data})
        case "SET_PLATFORM_STATISTICS_STATUS":
            return Object.assign({}, state, { platformStatisticsStatus: action.status })
        case "SET_TRANSCRIPTS_VIDEO_LIST":
            return Object.assign({}, state, { transcriptsVideoList: action.videos })
        case "SET_TRANSCRIPTS_VIDEO_LIST_STATUS":
            return Object.assign({}, state, { transcriptsVideoListStatus: action.status })
        case "SET_CLASS_CODE_DETAIL":
            return Object.assign({}, state, { classCodeDetail: action.detail })
        case "SET_CLASS_CODE_DETAIL_STATUS":
            return Object.assign({}, state, { classCodeDetailStatus: action.status })
        case "SET_CLASS_CODES_LIST":
            return Object.assign({}, state, { classCodesList: action.codes })
        case "SET_CLASS_CODES_LIST_STATUS":
            return Object.assign({}, state, { classCodesListStatus: action.status })
        case "SET_VIDEOS_TO_CURATE":
            return Object.assign({}, state, { videosToCurate: action.videos })
        case "SET_VIDEOS_TO_CURATE_STATUS":
            return Object.assign({}, state, { videosToCurateStatus: action.status })
        default:
            return state
    }
}